<template>
  <el-form :model="form" :rules="rules"></el-form>
</template>

<script>
import { getRevenueNewList } from '@/api/enterprise'

export default {
  props: ['ans', 'cb', 'userId'],
  data () {
    return {
      form: {},
      rules: {}
    }
  },
  mounted () {
    if (this.ans.version) {
      this.form = { result: this.ans.result, version: this.ans.version, year: this.ans.year, thisYear: this.ans.thisYear, lastYear: this.ans.lastYear }
    } else if (this.ans.thisYear && this.ans.lastYear) {
      this.form = { result: this.ans.result, thisYear: this.ans.thisYear, lastYear: this.ans.lastYear }
    } else {
      this.loadYear()
    }
  },
  methods: {
    loadYear () {
      getRevenueNewList(this.userId).then(res => {
        const revenue = res.data.sort((a, b) => a.year * 1 > b.year * 1 ? 1 : -1)
        const { personRevenue: personRevenue2023, personCount: personCount2023, year: year2023 } = revenue[2]
        const { personRevenue: personRevenue2022, personCount: personCount2022, year: year2022 } = revenue[1]
        const average2023 = personCount2023 === 0 ? 0 : (personRevenue2023 / personCount2023)
        const average2022 = personCount2022 === 0 ? 0 : (personRevenue2022 / personCount2022)
        const float2023 = average2023.toFixed(3)
        const float2022 = average2022.toFixed(3)
        const result = average2023 > average2022 ? 1 : (average2023 === average2022 ? 0 : -1)
        this.form = { result, version: 1, year: [year2022, year2023], thisYear: { personRevenue: personRevenue2023, personCount: personCount2023, average: float2023 }, lastYear: { personRevenue: personRevenue2022, personCount: personCount2022, average: float2022 } }
        this.cb(this.form, year2023)
      })
    }
  }
}
</script>
